import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetAdjustmentExporter  {
    _originalTypeClassName = "zERP.BO.BudgetAdjustmentExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetAdjustmentExporter.translate = translateService;
}
this.BudgetAdjustmentExporterKey = null;
this._key = this.BudgetAdjustmentExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BudgetAdjustmentExporterKey:any;
get BudgetAdjustmentExporterKey(): any {
    return this._BudgetAdjustmentExporterKey;
  }
set BudgetAdjustmentExporterKey(value: any) {
    this._BudgetAdjustmentExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(budgetAdjustment: any): any{let vars = new window['Map']();
let modificationsChildren = [];
modificationsChildren?.add({
Name: "account_code",Description: "Κωδικός λογαριασμού",}
);
modificationsChildren?.add({
Name: "account_description",Description: "Περιγραφή λογαριασμού",}
);
modificationsChildren?.add({
Name: "approved_amount",Description: "Εγκεκριμένο ποσό",}
);
modificationsChildren?.add({
Name: "adjustment_amount",Description: "Ποσό αναμόρφωσης",}
);
modificationsChildren?.add({
Name: "updated_amount",Description: "Ποσό λογαριασμού μετά την αναμόρφωση",}
);
vars.set({
Name: "MODIFICATIONS",Description: "Τροποποιήσεις λογαριασμών Π/Υ",IsCollection: true,Children: modificationsChildren,}
, Joove.Common.cast(budgetAdjustment?.Modifications, "System.Collections.List"));
return vars;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{if (collectionName == "MODIFICATIONS") {let budgetAdjustmentDetail = Joove.Common.cast(item, "Domain.BudgetAdjustmentDetail");switch (varName?.toLowerCase()) {case "account_code":
{
return budgetAdjustmentDetail?.BudgetDetail?.BudgetItem?.Code;}
case "account_description":
{
return budgetAdjustmentDetail?.BudgetDetail?.BudgetItem?.Name;}
case "approved_amount":
{
return budgetAdjustmentDetail?.BudgetDetail?.InitialApprovedAmount?.toString();}
case "adjustment_amount":
{
return budgetAdjustmentDetail?.ApprovedAmount?.toString();}
case "updated_amount":
{
return (Joove.Common.safeNumber(budgetAdjustmentDetail?.BudgetDetail?.InitialApprovedAmount) + Joove.Common.safeNumber(budgetAdjustmentDetail?.BudgetDetail?.AdjustmentsAmount))?.toString();}
}}
return "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BudgetAdjustmentExporterKey == null || $this.BudgetAdjustmentExporterKey == 0;
            }


}